import React, { useContext, useMemo, useState } from 'react'
import { Alert, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { getFromSession, text_convert_1 } from '../../helpers/GenericHelpers';
import historyLight from "../../images/lightLeftBarIcons/historyLight.png";
// import workFlowIcon from "../../images/workflow.png";
import workflowLight from "../../images/workflowLight.png";

import settingsIcon from "../../images/settings-basic.png";
import { IExtractesDataModel } from '../../models/ChatModels';
import ExtractedSettingsForm from './ExtractedSettingsForm';
import { toast } from 'react-toastify';
import { pushToLog } from '../../helpers/LogHelpers';
import { ILogsModel } from '../../models/LogsModel';
import { ProjectTypeEnum, ThemeTypes } from '../../models/SharedModel';
import { v4 as uuid } from "uuid";
import { ProjectStatus } from '../../models/ProjectModel';
import { ThemeContext } from '../../models/ThemeContext';

interface IExtractedDataProps {
  extractedData: IExtractesDataModel[];
  setExtractedData: React.Dispatch<React.SetStateAction<IExtractesDataModel[]>>
  saveCompliance: (data: any, callBack: Function) => void;
  project_main: any
}

const ExtractedData = (props: IExtractedDataProps) => {

  const { themeName } = useContext(ThemeContext);

  const images:string[]=
  (themeName === ThemeTypes.DARK_THEME) ?
   [historyLight, workflowLight]
  : [historyLight, workflowLight]
  const { extractedData, setExtractedData, saveCompliance, project_main } = props;
  const user_id = getFromSession("user_id");

  // states
  const [settingsModal, setSettingsModal] = useState(false)
  const [selectedData, setSelectedData] = useState<IExtractesDataModel | null>(null);

  const toggleSettingsModal = () => setSettingsModal(prev => !prev)

  // helpers
  const handleClear = () => {
    toggleSettingsModal()
    setSelectedData(null)
  }

  const callBack = (data: any) => {
    toggleSettingsModal()
    setSelectedData(null)
    // typeof data === 'string' && toast.success(data)
  }

  const handleSubmit = () => {
    const newData = extractedData?.map(each => each?.dataId === selectedData?.dataId ? selectedData : each )
    console.log(selectedData)
    if (
      selectedData?.roles?.length > 0 || 
      selectedData?.flags?.length > 0 ||
      selectedData?.monitor ||
      selectedData?.workflows?.length > 0
    ) {
      const violations: string[] = []
      if (selectedData?.roles?.length > 0) {
        violations.push('Role Restriction: User does not have access for this information')
      }
      if (selectedData?.flags?.length > 0) {
        violations.push(`Information is tagged under ${selectedData?.flags?.join(', ')}`)
      }
      // if (selectedData?.monitor) {
      //   violations.push(`The data is added to monitored list`)
      // }
      // if (selectedData?.workflows?.length > 0) {
      //   violations.push(`${selectedData?.flags?.join(', ')} workflows are added.`)
      // }

      const logData: ILogsModel = {
        log_id: uuid(),
        project_id: project_main?.project_id,
        username: user_id,
        solution: project_main?.project_name || "",
        solution_type: project_main?.project_type as ProjectTypeEnum,
        api: "/docai_save_compliance_to_pg",
        prompt: "",
        result: "",
        tags: selectedData?.flags,
        violations: violations,
        role: "USER",
        time: new Date(),
      };
      pushToLog(logData);
    }
    const newObject = {}
    // Todo: adding only specific fields - convert to dynamic
    newData?.forEach(each => {
      Object.assign(newObject, {
        [each?.label]: {
          flags: each?.flags,
          roles: each?.roles?.map((each: any) => each?.label),
          monitor: each?.monitor,
          workflows: each?.workflows?.map((each: any) => each?.label)
        }
      })
    })
    setExtractedData(newData)
    
    saveCompliance({ 'compliance_info' : newObject }, callBack)
  }


  // display functions
  const displayExtarctedData = () => {
    return extractedData?.map((each) => 
      <div className="extracted-item" key={each?.dataId}>
        <div className="extracted-item-title">
          <div className="left">
            <span className="extracted-value">{text_convert_1(each?.label)}</span>
            { each?.monitor ? <img src={images[0]} alt="clockIcon" className='clock-icon' /> : <></> }
            { each?.workflows?.length > 0 ? <img src={images[1]} alt="workFlowIcon" className='work-flow-icon' /> : <></>}
          </div>
          { each?.flags?.length > 0 ? 
            <div className="right">
              <div className="compliances-list">
                { each?.flags?.map((flag: string) => <div className={`compliances-item ${flag?.toLocaleLowerCase()}`} key={flag}>{flag}</div>) }
              </div>
            </div> : <></> }
        </div>
        <div className="extracted-item-data">
          <div className="item-data">
            {each?.value || 'Info not provided in doc'}
            { each?.roles?.length > 0 ? <div className="role-restricted">ROLE RESTRICTED</div> : <></>}
          </div>
          { [ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) ? <div className="item-settings" onClick={() => {
            setSelectedData(each)
            toggleSettingsModal()
          }}>
            <img src={settingsIcon} alt="settingsIcon" className='settings-icon' />
          </div> : <></>}
        </div>
      </div>
    )
  }

  return (
    <>
      { extractedData ? 
        <div className="extracted-inner">{displayExtarctedData()}</div> : 
        <div className="not-found">No data found</div> }
        
        {/* Extracted Settings Modal */}
        <Modal
          className={`project-modal extracted-settings ${themeName === ThemeTypes?.BLUE_THEME ? '' : 'dark-modal'}`}
          isOpen={settingsModal}
          fade={false}
          toggle={toggleSettingsModal}
        >
          <ModalHeader toggle={toggleSettingsModal}>Extracted Data Settings</ModalHeader>
          <ModalBody>
            <ExtractedSettingsForm
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              handleClear={handleClear}
              handleSubmit={handleSubmit}
            />
          </ModalBody>
        </Modal>
    </> 
  )
}

export default ExtractedData